export const FlattenBeforeMarketClose = {
  name: 'FLATTEN_BEFORE_MARKET_CLOSE',
  tacticLabel: 'Flatten Before Market Close',
};
